import React from 'react';
import {
 ConversationKind,
 ConversationStatus,
 KIND_COLOR,
 KIND_LABEL,
 STATUS_LABEL,
} from '../types';

const STATUS_TONE: Partial<Record<ConversationStatus, string>> = {
 pending: 'bg-yellow-100 text-yellow-800',
 countered: 'bg-orange-100 text-orange-800',
 accepted: 'bg-green-100 text-green-800',
 contracted: 'bg-emerald-100 text-emerald-800',
 paid: 'bg-emerald-200 text-emerald-900',
 settled: 'bg-emerald-200 text-emerald-900',
 rejected: 'bg-red-100 text-red-700',
 cancelled: 'bg-gray-200 text-gray-600',
 expired: 'bg-gray-200 text-gray-600',
 disputed: 'bg-rose-100 text-rose-800',
 archived: 'bg-gray-100 text-gray-500',
 acknowledged: 'bg-gray-100 text-gray-600',
 open: 'bg-blue-50 text-blue-700',
};

interface Props {
 kind: ConversationKind;
 status: ConversationStatus;
}

/** 대화의 kind + status 두 배지를 하나의 inline-flex 로 렌더. */
const StatusBadge: React.FC<Props> = ({ kind, status }) => (
 <div className="inline-flex items-center gap-1">
  <span className={`text-[10px] px-1.5 py-0.5 ${KIND_COLOR[kind]}`}>{KIND_LABEL[kind]}</span>
  <span className={`text-[10px] px-1.5 py-0.5 ${STATUS_TONE[status] ?? 'bg-gray-100 text-gray-600'}`}>
   {STATUS_LABEL[status] ?? status}
  </span>
 </div>
);

export default StatusBadge;
